// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1586":"59c6ae41","2521":"59c6ae41","4083":"59c6ae41","4653":"59c6ae41","4987":"59c6ae41","6305":"59c6ae41","9909":"59c6ae41"}[chunkId] + ".chunk.css";
};